const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getLeadSpecificDepositMethodsApi = async (leadId) => {
    const token = localStorage.getItem('token');
    const url = `${API_BASE_URL}/admin/lead/leads/${leadId}/deposit-methods`;

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось получить методы депозита лида.`);
        }

        const data = await response.json();

        return data.items || [];
    } catch (error) {
        throw error;
    }
};
